// extracted by mini-css-extract-plugin
export default {"TableInput":"TableInput_TableInput__k+oAw","container":"TableInput_container__CNKFE"};